export const ADD_FILES = 'add_files' as const;
export const REMOVE_FILE = 'remove_file' as const;
export const ERROR = 'error' as const;
export const PROGRESS = 'progress' as const;
export const SUCCESS = 'success' as const;
